import axios from 'axios'

const getAxios = (url, params) => { // get请求方法
  let data = axios.get(url, {params})
    .then(
      config => {
        return config
      }
    )
    .catch(
      err => {
        return err
      }
    )
  return data
}

const postAxios = (url, params) => {
  let data = axios.post(url, params)
    .then(
      config => {
        return config
      }
    )
    .catch(
      err => {
        return err
      }
    )
  return data
}

const putAxios = (url, params) => {
  let data = axios.put(url, params)
    .then(
      config => {
        return config
      }
    )
    .catch(
      err => {
        return err
      }
    )
  return data
}

const deleteAxios = (url, params) => { // delete
  let data = axios.delete(url, {params})
    .then(
      config => {
        return config
      }
    )
    .catch(
      err => {
        return err
      }
    )
  return data
}

export default {
  getAxios,
  postAxios,
  putAxios,
  deleteAxios
}


// WEBPACK FOOTER //
// ./src/api/index.js